import update from 'immutability-helper';
import debounce from 'lodash/debounce';
import values from 'lodash/values';
import { object } from '../../../schema';

import { CALL_API } from '../../../middleware/api';

const FILTER_TOGGLE_TYPE = 'browser/FILTER_TOGGLE_TYPE';
const FILTER_CHANGE_TERM = 'browser/FILTER_CHANGE_TERM';
const FILTER_SET_RANGE = 'browser/FILTER_SET_RANGE';
const FILTER_SET_TYPE = 'browser/FILTER_SET_TYPE';
const FILTER_SET_DISTRICT = 'browser/FILTER_SET_DISTRICT';
const FILTER_RESET = 'browser/FILTER_RESET';

const LOAD = 'browser/LOAD';
const LOAD_SUCESS = 'browser/LOAD_SUCESS';
const LOAD_FAIL = 'browser/LOAD_FAIL';


const fetch = (endpoint = 'objects/', payload) => ({
  [CALL_API]: {
    types: [LOAD, LOAD_SUCESS, LOAD_FAIL],
    endpoint,
    method: 'GET',
    schema: [object],
    payload
  }
});

export const load = fetch;


const search = () => (dispatch, getState) => {
  const { term, types } = getState().browser.filter;

  const payload = {
    term,
    types: Object.keys(types).filter(type => types[type]).join(),
  };

  return dispatch(fetch('objects/search/', payload));
};

const debouncedSearch = debounce(dispatch => dispatch(search()), 200);

export const toggleType = objecType => dispatch => {
  dispatch({
    objecType,
    type: FILTER_TOGGLE_TYPE,
  });
};

export const setType = objecType => ({
  objecType,
  type: FILTER_SET_TYPE
});

export const changeTerm = term => dispatch => {
  dispatch({
    term,
    type: FILTER_CHANGE_TERM
  });

  debouncedSearch(dispatch);
};

export const setRange = ([min, max]) => ({
  min,
  max,
  type: FILTER_SET_RANGE
});

export const setDistrict = district => ({
  district,
  type: FILTER_SET_DISTRICT,
});

export const reset = () => (dispatch, getState) => {
  dispatch({
    type: FILTER_RESET
  });
  dispatch(search());
}

const initialState = {
  items: [],
  range: undefined,
  loading: false,
  filter: {
    types: {
      wall: true,
      pale: true,
      //overpass: true,
    },
    min: undefined,
    max: undefined,
    term: '',
    district: ''
  }
};

const disabledTypes = {
  wall: false,
  pale: false,
  //overpass: false
}

const getRange = products => {
  let min = undefined;
  let max = undefined;

  values(products).forEach(({monthlyEstimate}) => {
    if (typeof min === 'undefined' || min > monthlyEstimate) {
      min = monthlyEstimate;
    }
    if (typeof max === 'undefined' || max < monthlyEstimate) {
      max = monthlyEstimate;
    }
  });

  if (typeof min === 'undefined') {
    min = 0;
  }
  if (typeof max === 'undefined') {
    max = 0;
  }

  return { min: Math.floor(min), max: Math.ceil(max) };
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return {...state, loading: true }

    case LOAD_SUCESS:
      return {
        ...state,
        loading: false,
        items: action.response.result,
        range: action.response.entities.products 
          ? getRange(action.response.entities.products)
          : state.range
      }

    case FILTER_TOGGLE_TYPE:
      return update(state, {filter: {types: { [action.objecType]: {$set: !state.filter.types[action.objecType] }}}});

    case FILTER_SET_TYPE:
      return update(state, {filter: {types: {$set: {...disabledTypes, [action.objecType]: true} }}});      

    case FILTER_CHANGE_TERM:
      return update(state, {filter: {term: {$set: action.term }}});

    case FILTER_SET_DISTRICT:
      return update(state, {filter: {district: {$set: action.district }}});

    case FILTER_RESET:
      return update(state, {filter: {$set: {
        ...initialState.filter,
        min: state.range.min,
        max: state.range.max
      } }});

    case FILTER_SET_RANGE:
      return update(state, {filter: {
        min: {$set: action.min },
        max: {$set: action.max }
      }})

    default: 
      return state
  }
}




// WEBPACK FOOTER //
// ./src/redux/modules/browser/index.js